const _ = "styles-module__link___UYtsZ", l = {
  link: _,
  "link--lowercase": "styles-module__link--lowercase___G4Hv4",
  "link--uppercase": "styles-module__link--uppercase___Xvr05",
  "link--capitalize": "styles-module__link--capitalize___3IBUj",
  "link--text-align-left": "styles-module__link--text-align-left___sEgpI",
  "link--text-align-right": "styles-module__link--text-align-right___K4Ypm",
  "link--text-align-center": "styles-module__link--text-align-center___WiB53",
  "link--text-align-justify": "styles-module__link--text-align-justify___UkN-M",
  "link--size-n3": "styles-module__link--size-n3___h1g2-",
  "link--size-n2": "styles-module__link--size-n2___CSW1e",
  "link--size-n1": "styles-module__link--size-n1___QHmiS",
  "link--size-0": "styles-module__link--size-0___GN8Px",
  "link--size-1": "styles-module__link--size-1___86bNz",
  "link--size-2": "styles-module__link--size-2___X6YH0",
  "link--size-3": "styles-module__link--size-3___3CAsR",
  "link--size-4": "styles-module__link--size-4___0nnpA",
  "link--size-5": "styles-module__link--size-5___wDbib",
  "link--bold": "styles-module__link--bold___xeED2",
  "link--semibold": "styles-module__link--semibold___kPvl-",
  "link--regular": "styles-module__link--regular___ZY82q",
  "link--primary": "styles-module__link--primary___XNT-y",
  "link--primary-blue": "styles-module__link--primary-blue___ms6uP",
  "link--primary-dark": "styles-module__link--primary-dark___uYjVO",
  "link--primary-light": "styles-module__link--primary-light___kMAfT",
  "link--primary-brand": "styles-module__link--primary-brand___6dgwy",
  "link--secondary": "styles-module__link--secondary___Ppgpa",
  "link--secondary-50": "styles-module__link--secondary-50___murrY",
  "link--secondary-100": "styles-module__link--secondary-100___yMaM0",
  "link--secondary-200": "styles-module__link--secondary-200___OQMqt",
  "link--secondary-300": "styles-module__link--secondary-300___KzqNc",
  "link--secondary-400": "styles-module__link--secondary-400___yC95z",
  "link--secondary-500": "styles-module__link--secondary-500___ngxp8",
  "link--secondary-600": "styles-module__link--secondary-600___tj2OK",
  "link--secondary-700": "styles-module__link--secondary-700___4el3T",
  "link--secondary-800": "styles-module__link--secondary-800___sec6D",
  "link--secondary-900": "styles-module__link--secondary-900___WNIm1",
  "link--tertiary": "styles-module__link--tertiary___HNL52",
  "link--tertiary-50": "styles-module__link--tertiary-50___KryOe",
  "link--tertiary-100": "styles-module__link--tertiary-100___XZwbz",
  "link--tertiary-200": "styles-module__link--tertiary-200___0JD5O",
  "link--tertiary-300": "styles-module__link--tertiary-300___7LGWl",
  "link--tertiary-400": "styles-module__link--tertiary-400___WiGYs",
  "link--tertiary-450": "styles-module__link--tertiary-450___Agsc4",
  "link--tertiary-500": "styles-module__link--tertiary-500___jvuV8",
  "link--tertiary-600": "styles-module__link--tertiary-600___C-z5N",
  "link--tertiary-700": "styles-module__link--tertiary-700___cBS3N",
  "link--tertiary-800": "styles-module__link--tertiary-800___Wsea0",
  "link--tertiary-900": "styles-module__link--tertiary-900___uHOv0",
  "link--quaternary": "styles-module__link--quaternary___NJoDa",
  "link--quaternary-50": "styles-module__link--quaternary-50___zTtxf",
  "link--quaternary-100": "styles-module__link--quaternary-100___9XUM8",
  "link--quaternary-200": "styles-module__link--quaternary-200___NgZ3a",
  "link--quaternary-300": "styles-module__link--quaternary-300___rG007",
  "link--quaternary-400": "styles-module__link--quaternary-400___-yovG",
  "link--quaternary-500": "styles-module__link--quaternary-500___XVi0n",
  "link--quaternary-600": "styles-module__link--quaternary-600___Ki2pG",
  "link--quaternary-700": "styles-module__link--quaternary-700___iYJg-",
  "link--quaternary-800": "styles-module__link--quaternary-800___ZtMom",
  "link--quaternary-900": "styles-module__link--quaternary-900___g1ei1",
  "link--info": "styles-module__link--info___WBz3b",
  "link--info-50": "styles-module__link--info-50___FF2iv",
  "link--info-100": "styles-module__link--info-100___eboNh",
  "link--info-200": "styles-module__link--info-200___HPXo9",
  "link--info-300": "styles-module__link--info-300___JZEbA",
  "link--info-400": "styles-module__link--info-400___snzpq",
  "link--info-500": "styles-module__link--info-500___CUsg3",
  "link--info-600": "styles-module__link--info-600___vX310",
  "link--info-700": "styles-module__link--info-700___aSr4B",
  "link--info-800": "styles-module__link--info-800___TiFIC",
  "link--info-900": "styles-module__link--info-900___4W9zW",
  "link--success": "styles-module__link--success___o0S5C",
  "link--success-50": "styles-module__link--success-50___3dhiR",
  "link--success-100": "styles-module__link--success-100___MDN3u",
  "link--success-200": "styles-module__link--success-200___PtA1z",
  "link--success-300": "styles-module__link--success-300___-PEGY",
  "link--success-400": "styles-module__link--success-400___1aN3-",
  "link--success-500": "styles-module__link--success-500___FXOw7",
  "link--success-600": "styles-module__link--success-600___B1rPe",
  "link--success-700": "styles-module__link--success-700___dP6Ux",
  "link--success-800": "styles-module__link--success-800___LOpgV",
  "link--success-900": "styles-module__link--success-900___h2S73",
  "link--alert": "styles-module__link--alert___OOwXA",
  "link--alert-50": "styles-module__link--alert-50___Qmzy7",
  "link--alert-100": "styles-module__link--alert-100___TdARv",
  "link--alert-200": "styles-module__link--alert-200___eOFDM",
  "link--alert-300": "styles-module__link--alert-300___kASxQ",
  "link--alert-400": "styles-module__link--alert-400___xz97c",
  "link--alert-500": "styles-module__link--alert-500___A0UIu",
  "link--alert-600": "styles-module__link--alert-600___u243o",
  "link--alert-700": "styles-module__link--alert-700___mrn6V",
  "link--alert-800": "styles-module__link--alert-800___oz5o6",
  "link--alert-900": "styles-module__link--alert-900___-uoSJ",
  "link--error": "styles-module__link--error___nthVG",
  "link--error-50": "styles-module__link--error-50___ZKJCI",
  "link--error-100": "styles-module__link--error-100___fbPVp",
  "link--error-200": "styles-module__link--error-200___mBXau",
  "link--error-300": "styles-module__link--error-300___1HX1k",
  "link--error-400": "styles-module__link--error-400___54skc",
  "link--error-500": "styles-module__link--error-500___T4Cro",
  "link--error-600": "styles-module__link--error-600___XmEf2",
  "link--error-700": "styles-module__link--error-700___zPJ2i",
  "link--error-800": "styles-module__link--error-800___GaJ1I",
  "link--error-900": "styles-module__link--error-900___VdswV",
  "link--neutral": "styles-module__link--neutral___CYqS5",
  "link--neutral-50": "styles-module__link--neutral-50___br-UD",
  "link--neutral-100": "styles-module__link--neutral-100___0ocTj",
  "link--neutral-150": "styles-module__link--neutral-150___ubOm4",
  "link--neutral-200": "styles-module__link--neutral-200___cLpWZ",
  "link--neutral-300": "styles-module__link--neutral-300___VHBxI",
  "link--neutral-400": "styles-module__link--neutral-400___cgfeb",
  "link--neutral-500": "styles-module__link--neutral-500___JZnIB",
  "link--neutral-600": "styles-module__link--neutral-600___4JU1V",
  "link--neutral-700": "styles-module__link--neutral-700___7-c0Y",
  "link--neutral-800": "styles-module__link--neutral-800___1CbIB",
  "link--neutral-900": "styles-module__link--neutral-900___5aWER",
  "link--grey": "styles-module__link--grey___QLVVH",
  "link--grey-50": "styles-module__link--grey-50___C4g-t",
  "link--grey-100": "styles-module__link--grey-100___fT4AR",
  "link--grey-200": "styles-module__link--grey-200___ezh5E",
  "link--grey-300": "styles-module__link--grey-300___GGhaP",
  "link--grey-400": "styles-module__link--grey-400___1HtNe",
  "link--grey-500": "styles-module__link--grey-500___R9QKe",
  "link--grey-600": "styles-module__link--grey-600___j-Ige",
  "link--grey-700": "styles-module__link--grey-700___TrK14",
  "link--grey-800": "styles-module__link--grey-800___Z2DXJ",
  "link--grey-900": "styles-module__link--grey-900___7hHl8",
  "link--background": "styles-module__link--background___uLKig",
  "link--background-200": "styles-module__link--background-200___sqwSe",
  "link--background-full-white": "styles-module__link--background-full-white___9wqZp",
  "link--background-grey-50": "styles-module__link--background-grey-50___pHCtx",
  "link--background-neutral-50": "styles-module__link--background-neutral-50___PDuQu",
  "link--background-grey-100": "styles-module__link--background-grey-100___AoSD9",
  "link--background-tertiary": "styles-module__link--background-tertiary___NYNt3",
  "link--background-error": "styles-module__link--background-error___X-utc",
  "link--background-tertiary-600": "styles-module__link--background-tertiary-600___6VRnV",
  "link--background-error-600": "styles-module__link--background-error-600___Si0SR",
  "link--background-neutral-900": "styles-module__link--background-neutral-900___S3i0b",
  "link--background-neutral-legacy": "styles-module__link--background-neutral-legacy___IpaZ5",
  "link--background-win": "styles-module__link--background-win___DNYez",
  "link--typography": "styles-module__link--typography___k8TO7",
  "link--typography-white": "styles-module__link--typography-white___WrNDn",
  "link--typography-default": "styles-module__link--typography-default___8eYBW",
  "link--typography-link": "styles-module__link--typography-link___gwVUd",
  "link--typography-error": "styles-module__link--typography-error___gThq5",
  "link--typography-sucess": "styles-module__link--typography-sucess___rbpDV",
  "link--typography-disabled": "styles-module__link--typography-disabled___eH-6k",
  "link--typography-marketing": "styles-module__link--typography-marketing___IQhu7",
  "link--typography-secondary": "styles-module__link--typography-secondary___cRo0v",
  "link--icons-white": "styles-module__link--icons-white___MCmXJ",
  "link--icons-dark-grey": "styles-module__link--icons-dark-grey___khg1G",
  "link--icons-blue": "styles-module__link--icons-blue___njC--",
  "link--icons-red": "styles-module__link--icons-red___K-u7a",
  "link--icons-success": "styles-module__link--icons-success___FgU7y",
  "link--icons-warning": "styles-module__link--icons-warning___w1G7b",
  "link--icons-info": "styles-module__link--icons-info___Gn0t-",
  "link--icons-win": "styles-module__link--icons-win___-Pkmc",
  "link--accent": "styles-module__link--accent___-gg6F",
  "link--accent-orange": "styles-module__link--accent-orange___FXa2Y",
  "link--accent-light": "styles-module__link--accent-light___M6jCF",
  "link--underlined": "styles-module__link--underlined___aXuga"
};
export {
  l as default,
  _ as link
};
